import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { name: '首页', path: '/' },
  { name: '今日大瓜', path: '/category/today-hot' },
  { name: '网红黑料', path: '/category/influencer-scandal' },
  { name: '明星塌房', path: '/category/celebrity-downfall' },
  { name: '实时爆料', path: '/category/realtime-expose' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap" aria-label="911爆料网首页">
            <span className="text-2xl">🔥</span>
            <span className={`font-heading text-xl font-bold tracking-tight ${scrolled || !isHome ? 'text-foreground-900' : 'text-white'}`}>
              911爆料网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium whitespace-nowrap transition-colors duration-200 hover:text-primary-500 ${
                  location.pathname === item.path
                    ? 'text-primary-500'
                    : scrolled || !isHome
                      ? 'text-foreground-700'
                      : 'text-white/90'
                }`}
              >
                {item.name}
              </Link>
            ))}
          </div>

          <div className="flex items-center gap-3">
            <Link
              to="/about"
              className={`hidden md:inline-flex items-center gap-1.5 px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-primary-600`}
            >
              <i className="ri-alarm-warning-line text-base w-4 h-4 flex items-center justify-center"></i>
              紧急爆料
            </Link>

            <button
              className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg cursor-pointer"
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-label="菜单"
            >
              <i className={`text-xl ${scrolled || !isHome ? 'text-foreground-800' : 'text-white'} ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} w-5 h-5 flex items-center justify-center`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50/98 backdrop-blur-md border-t border-background-200/60">
          <div className="px-4 py-4 flex flex-col gap-3">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm font-medium py-2 px-3 rounded-lg transition-colors ${
                  location.pathname === item.path
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {item.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="mt-2 flex items-center justify-center gap-1.5 w-full py-2.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600"
            >
              <i className="ri-alarm-warning-line text-base w-4 h-4 flex items-center justify-center"></i>
              紧急爆料
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}